export default __webpack_public_path__ + "static/Vault-bc3a08e12567acc962d00864b11d33f1.png";